<template>
    <div>
        <h1 class="pageHeader">
            <span class="pageHeader__title">Overview</span>
        </h1>

        <table class="table table--awd table--awd-title" id="blocks">
            <tbody>
            <tr class="table__header">
                <th class="table__title table__title--low">Height</th>
                <th class="table__title table__title--low">Time Ago</th>
                <th class="table__title table__title--low">Transactions</th>
                <th class="table__title table__title--low">Total Sent</th>
                <th class="table__title table__title--low">Block Size</th>
                <th class="table__title table__title--low"></th>
            </tr>
            <tr v-for="block in blocks"
                :key='block.height'
                class="table__row">
                <td data-th="Height" class="table__cell">
                    <router-link :to="{ path: '/block/' + block.height }"
                                 class="link">
                        {{ block.height }}
                    </router-link>
                </td>
                <td data-th="Time ago" class="table__cell">
                    <timeago :since="block.time * 1000"
                             :auto-update="30"
                             class="timeago txt-gray"> </timeago>
                </td>
                <td data-th="Transactions" class="table__cell txt-white"> {{ block.txCount }} </td>
                <td data-th="Total Sent" class="table__cell txt-green"> {{ block.coinsSent | formatPlc }} </td>
                <td data-th="Block Size" class="table__cell txt-gray"> {{ block.size }} </td>
                <td v-if='block.new'>
                  <button type="button"
                          @mouseover='block.new = false'
                          class="btn btn-sm btn-info isnew hidden">New</button>
                </td>
                <td v-else class="table__cell hidden-xs-down"></td>
            </tr>
            </tbody>
        </table>

        <div class="row">
            <div class="col-lg-6 mt-5">
                <div class="table__header table__header--transactions table__title--capitalize">
                    <img class="icon" src="../assets/img/check-box.png" alt="check-box">
                    Latest Transactions
                </div>

                <table class="table table--awd" id="txs">
                    <tbody>
                    <tr class="table__row"></tr>
                    <tr v-for="tx in txs"
                        :key='tx.txid'
                        class="table__row">
                      <template v-if="tx.type && tx.type == 'minting'">
                        <td class="table__cell table__cell--low">
                          <img class="table__cell-size-low"
                             title="Minting Transaction"
                             src="../assets/img/arrow-minting.png"/>
                        </td>
                      </template>
                      <template v-else>
                        <td class="table__cell table__cell--low">
                          <img class="table__cell-size-low"
                             title="Normal Transaction"
                             src="../assets/img/arrow-usual.png"/>
                        </td>
                      </template>
                      <td class="table__cell table__cell--low">
                          <router-link :to="{ path: '/tx/' + tx.txid }"
                                       class="link">
                              {{ tx.txid.substring(0, 20) }} ...
                          </router-link>
                      </td>
                      <td class="table__cell table__cell--low">
                          <timeago :since="tx.time * 1000"
                                   :auto-update="60"
                                   class="timeago txt-gray"> </timeago>
                      </td>
                      <td class="table__cell table__cell--low">
                          <button type="button" class="table__button table__button--positive">
                            {{ tx.outputsValue | formatPlc }}
                          </button>
                      </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div class="col-lg-6 mt-5">
                <search>
                    <div class="blockSearch mb-5" id="home-search-container" slot-scope="{ search_form, searchId, onInput }">
                        <h3 class="blockSearch__header">
                            <img class="icon" src="../assets/img/search.png" alt="check-box">
                            Search
                        </h3>
                        <div class="blockSearch__body">
                            <p class="blockSearch__description">You may enter a block height, address, block hash or transaction hash...</p>
                            <div class="blockSearch__form" id="overviewSearchForm">
                                <input :value="search_form"
                                       @input="onInput"
                                       @keyup.enter="searchId"
                                       class="blockSearch__input" type="text" id="overviewSearchInput"
                                       placeholder="Height / address / block hash / transaction hash"
                                       autofocus="" required="">
                                <button @click="searchId"
                                        class="blockSearch__button"
                                        type="submit" value="Search"
                                        id="searchButton">
                                    <img class="blockSearch__icon hidden-sm-up" src="../assets/img/search.png" alt="Search">
                                    <span class="hidden-xs-down">Search</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </search>
                <div class="blockSearch mb-5" id="stats">
                    <h3 class="blockSearch__header">
                        <img class="icon" src="../assets/img/locked-padlock.png" alt="check-box">
                        Network Summary
                    </h3>
                    <div class="blockSearch__body">
                        <div class="blockSearch__row">
                            <div class="blockSearch__cell txt-gray">Blocks</div>
                            <div class="txt-white">{{ info.blocks }}</div>
                        </div>
                        <div class="blockSearch__row">
                            <div class="blockSearch__cell txt-gray">Difficulty</div>
                            <div class="txt-white">{{ info.difficulty }}</div>
                        </div>
                        <div class="blockSearch__row">
                            <div class="blockSearch__cell txt-gray">Hashing Power</div>
                            <div class="txt-white">{{ info.networkhashps }}</div>
                        </div>
                        <div class="blockSearch__row">
                            <div class="blockSearch__cell txt-gray">Default Fee</div>
                            <div class="txt-white">{{ info.defaultfee }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Search from './base/Search'
import ApiService from '../service/ApiService'

export default {
  name: 'Overview',

  components: { Search },

  data: () => ({
    blocks: [],
    blocks_map: {},
    txs: [],
    txs_map: {},
    info: { blocks: 0, difficulty: 0, networkhashps: 0, defaultfee: 0 }
  }),

  watch: {
    $route: 'fetchData'
  },

  created () {
    const this_wrapper = this
    this.timerId = setInterval(function () {
      this_wrapper.fetchData(true)
    }, 15000)

    this.fetchData()
  },

  beforeDestroyed () {
    clearInterval(this.timerId)
  },

  methods: {
    async fetchData (is_new) {
      try {
        /* Fetch information */
        this.info = await ApiService.getInfo()
        /* Fetch blocks */
        const blocks = await ApiService.getBlocks()
        for (let block of blocks.reverse()) {
          // check that we havnt'd inserted block before
          if (!this.blocks_map[block.hash]) {
            block.new = is_new
            this.blocks.unshift(block)
            this.blocks_map[block.hash] = true
            if (is_new) {
              block = this.blocks.pop()
              this.blocks_map[block.hash] = undefined
            }
          }
        }
        /* Fetch transactions */
        const txs = await ApiService.getTransactions()
        for (let tx of txs.reverse()) {
          // check that we havnt'd inserted transactions before
          if (!this.txs_map[tx.txid]) {
            tx.new = is_new
            this.txs.unshift(tx)
            this.txs_map[tx.txid] = true
            if (is_new) {
              tx = this.txs.pop()
              this.txs_map[tx.hash] = undefined
            }
          }
        }
      } catch (error) {
        let obj = {
          title: 'Oops!',
          message: 'Internal error. Please let us know.',
          type: 'error'
        }
        this.$root.$children[0].$refs.simplert.openSimplert(obj)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Overview.vue